<template>
  <div class="connect-motion-bank-landing">
    <router-link to="/dashboard">
      <div class="back-button-connect">
        <svg width="10" height="15" viewBox="0 0 10 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.14888 0.831011L1.07322 5.90668C0.308927 6.67097 0.308927 7.90559 1.07322 8.66988L6.14888 13.7455C7.38351 14.9802 9.5 14.0983 9.5 12.3541L9.5 2.20281C9.5 0.458665 7.38351 -0.40361 6.14888 0.831011Z" fill="#C62127"/>
        </svg>
        Kembali ke Dashboard Partai Perindo
      </div>
    </router-link>
    <div class="connect-motion-bank-content">
      <img src="../../../assets/images/Illustration-motion-bank.png" alt="">
      <div class="content-registration">
        <img src="../../../assets/images/motionbank-logo.png" alt="">
        <span class="text-bold text-2xl text-center">Daftar dan Lengkapi</span>
        <p class="text-center">Kewajiban pengurus anggota untuk daftar & lengkapi MotionBanking di aplikasi Partai Perindo</p>
        <button class="button-primary-outline text-bold w-full p-1rem" @click="showDownloadPopup = true"> Belum Terdaftar</button>
        <button class="button-primary text-bold w-full p-1rem" @click="$router.push({ name: 'AddAccountMotionBank' })"> Sudah Terdaftar</button>
        <span class="helper w-full">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="12" fill="#C62127"/>
            <path d="M10 7C11.95 7 13.5 8.55 13.5 10.5C13.5 11.7 12.9 12.75 12 13.35V14.5C12 14.8 11.8 15 11.5 15H8.5C8.2 15 8 14.8 8 14.5V13.35C7.1 12.75 6.5 11.7 6.5 10.5C6.5 8.55 8.05 7 10 7ZM8.5 16.5V16H11.5V16.5C11.5 16.8 11.3 17 11 17H9C8.7 17 8.5 16.8 8.5 16.5ZM10 8C8.6 8 7.5 9.1 7.5 10.5C7.5 11.55 8.1 12.4 9 12.8V14H11V12.8C11.9 12.4 12.5 11.55 12.5 10.5C12.5 9.1 11.4 8 10 8ZM16.25 13.25V14H15.5V13.25H16.25ZM15.25 10.75H14.5V10.5C14.5 9.65 15.15 9 16 9C16.85 9 17.5 9.65 17.5 10.5C17.5 11 17.25 11.45 16.85 11.7L16.7 11.8C16.4 12 16.25 12.3 16.25 12.65V12.75H15.5V12.65C15.5 12.05 15.8 11.5 16.3 11.2L16.45 11.1C16.65 10.95 16.75 10.75 16.75 10.5C16.75 10.1 16.4 9.75 16 9.75C15.6 9.75 15.25 10.1 15.25 10.5V10.75Z" fill="#F3F6FF"/>
          </svg>
          Anda Butuh bantuan ? Hubungi 1500 188
        </span>
      </div>
    </div>
  </div>
  <PopUpDownloadMotionBank v-if="showDownloadPopup" @close="showDownloadPopup = !showDownloadPopup" />
</template>

<script setup>
import { ref } from 'vue'
import PopUpDownloadMotionBank from './Components/PopUpDownloadMotionBank.vue'

const showDownloadPopup = ref(false)
</script>

<style lang="scss" scoped>

.connect-motion-bank-landing {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4rem;

  @media screen and (max-width: 600px) {
    gap: 1rem;
  }

  .back-button-connect {
    display: flex;
    align-items: center;
    gap: .5rem;

    color: #ED1C24;
    font-weight: 500;
  }

  .connect-motion-bank-content {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 3rem;

    @media screen and (max-width: 600px) {
      flex-direction: column;
    }

    img {
      width: 350px;
    }

    .content-registration {
      max-width: 500px;
      display: flex;
      flex-direction: column;
      gap: 1rem;
      justify-content: center;
      align-items: center;
      color: #152A4C;
      img {
        width: 192px;
        margin-bottom: 2rem;
      }
      .helper {
        display: flex;
        gap: 1rem;
        justify-content: center;
        align-items: center;
        background: #FFC4C6;
        border-radius: 5px;
        padding: 1rem;
        font-weight: 700;
        color: $blue;
      }
    }
  }
}
</style>
